import React from 'react';
import { Typography } from 'antd';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import Box from '../../../../shared/ui/Box';
import { Table } from '../../../base/Table';
import { useCanChangeLifeCycle } from '../../services/accessesProvider';
import LifeCycleWrapper from '../LifeCycleWrapper';

export const StageCell = ({ record, column, row }) => {
  const { open } = useModalMethods();

  const {
    stageAddressLifeCycle: { name },
  } = record;

  const canChange = useCanChangeLifeCycle();

  const handleClick = canChange
    ? () => {
        open(modalNames.changeRoomStage, { room: record });
      }
    : undefined;

  const Component = name ? Box : Typography.Text;

  const text = name || 'Не установлено';

  return (
    <Table.BodyCell
      column={column}
      row={row}
      type={!name ? 'default' : undefined}
    >
      <LifeCycleWrapper
        tooltipTitle={canChange ? 'Изменить стадию' : undefined}
      >
        <Component onClick={handleClick}>{text}</Component>
      </LifeCycleWrapper>
    </Table.BodyCell>
  );
};

export default StageCell;
